import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'

export const setIsGetPhoneNumber = (isGetPhoneNumber: boolean) => dispatch => {
  dispatch(
    action(USER_ACTION_TYPES.set_is_phone_number, {
      isGetPhoneNumber
    })
  )
}



// WEBPACK FOOTER //
// ./src/store/user/actions/setIsGetPhoneNumber.action.ts